import React, { Component } from 'react'
import Header from './Header/Header';
import AboutContainer from './About/AboutContainer';
import { Helmet } from 'react-helmet';
import CardContainer from './Cards/CardContainer';
import Why from './Why/Why';
import Choose from './Choose/Choose';
import DematAccount from './DematAccount/DematAccount';

export class Home extends Component {
  render() {
    return (
      <>
      <Helmet>
        <title>
          OPG Securities ~ Home
        </title>
      </Helmet>
        <div className="wrapper">
          <Header />
          <AboutContainer />
          <CardContainer />
          <Why />
          <Choose />
          <DematAccount />
        </div>
      </>
    )
  }
}

export default Home;